const getBrowser = (userAgent) => {
  if (/Edg\//.test(userAgent)) return "Edge";
  if (/OPR\//.test(userAgent)) return "Opera";
  if (/Chrome\//.test(userAgent)) return "Chrome";
  if (/Firefox\//.test(userAgent)) return "Firefox";
  if (/Safari\//.test(userAgent)) return "Safari";
  return "Unknown";
};

const getOS = (userAgent) => {
  if (/Windows/.test(userAgent)) return "Windows";
  if (/Mac OS/.test(userAgent)) return "Mac";
  if (/Android/.test(userAgent)) return "Android";
  if (/iPhone|iPad|iPod/.test(userAgent)) return "iOS";
  if (/Linux/.test(userAgent)) return "Linux";
  return "Unknown";
};

const getDevice = (userAgent) => {
  if (/iPad|Tablet/i.test(userAgent)) return "Tablet";
  if (/Mobi|Android|iPhone/i.test(userAgent)) return "Mobile";
  return "Desktop";
};

const isSafeBrowser = (userAgent) => /SEB/i.test(userAgent);

export const getClientInfo = ({ endTime, heartbeatData, isForceLogout } = {}) => {
  const userAgent = navigator.userAgent || "";
  const now = new Date();
  return {
    userAgent,
    browser: getBrowser(userAgent),
    os: getOS(userAgent),
    device: getDevice(userAgent),
    clientDateTime: now.toISOString(),          // UTC timestamp
    clientLocalDateTime: now.toString(),     
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    cpuCores: navigator.hardwareConcurrency ?? null,
    deviceMemory: navigator.deviceMemory ?? null,
    platform: navigator.platform,
    touchSupport: "ontouchstart" in window || navigator.maxTouchPoints > 0,
    safeBrowser: isSafeBrowser(userAgent),
    currentUrl: window.location.href,
    fullscreen: !!document.fullscreenElement,
    heartbeatData: heartbeatData ?? null,
    endTime: endTime ?? null,
    isForceLogout: !!isForceLogout,
    localStorageExamEndTime: localStorage.getItem("examEndTime") ?? "",
    localStorageExamEndTimeExists: localStorage.getItem("examEndTime") !== null,
  };
};
